/* eslint-disable indent */
import Image from "next/image";
import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import {
    Span,
    SubTitle as StyledSubtitle,
} from "utils/styling/typography.styled";

export const LeaderboardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    border-radius: 1rem;
`;

export const LeaderboardContainer = styled.div`
    background: ${colourScheme.primary};
    border-radius: 1rem;
`;

export const SubTitle = styled(StyledSubtitle)`
    margin: 1rem 0;
    text-align: center;
`;

export const LeaderboardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    padding: 0 1rem;
    background: ${colourScheme.primary};
    width: 100%;
`;

export const UserCard = styled.div<{ rank: number }>`
    background: ${({ rank }) =>
        rank === 1
            ? colourScheme.secondary
            : rank === 2
              ? colourScheme.primaryLight
              : colourScheme.primaryLight};
    padding: 1rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: ${({ rank }) => (rank === 1 ? "35%" : rank === 2 ? "33%" : "32%")};
    height: ${({ rank }) => (rank === 1 ? "10rem" : "8rem")};
    top: ${({ rank }) => (rank === 1 ? "0rem" : "1rem")};

    ${device.md} {
        width: ${({ rank }) =>
            rank === 1 ? "35%" : rank === 2 ? "33%" : "32%"};
        height: ${({ rank }) => (rank === 1 ? "12rem" : "10rem")};
        top: ${({ rank }) => (rank === 1 ? "0rem" : "1rem")};
    }
    position: relative;
    text-align: center;
`;

export const UsernameContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
    width: 100%;
    max-width: 100%;
`;

export const Username = styled(Span)`
    font-weight: bold;
    color: ${colourScheme.fullWhite};
    font-size: clamp(0.8rem, 1.2vw, 1.4rem);
    margin-top: -2rem;
    width: 100%;
    max-width: 100%;
    white-space: normal;
    word-break: break-all;
`;

export const ProfilePicture = styled(Image)`
    border-radius: 50%;
    position: relative;
    width: 4.5rem;
    height: 4.5rem;
    top: -2rem;
`;

export const VoteCount = styled(Span)`
    margin-top: 0.5rem;
    font-size: 1.5rem;
    font-weight: bold;
`;

export const LeaderboardList = styled.ol`
    margin-top: 0.5rem;
`;

export const ListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
    background: ${colourScheme.primaryDark};
    border-radius: 1rem;

    &:nth-of-type(odd) {
        background: ${colourScheme.primaryLight};
    }
`;

export const ListProfilePicture = styled(Image)`
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
`;

export const ListRank = styled(Span)`
    margin-right: 1rem;
    font-weight: normal;
`;

export const ListUsername = styled(Span)`
    font-weight: bold;
    margin-left: 1rem;
`;

export const ListVoteCount = styled(Span)`
    margin-left: auto;
    font-weight: bold;
    color: ${colourScheme.fullWhite};
    font-size: 1rem;
`;

export const Rank = styled.div`
    font-size: 1rem;
    font-weight: bold;
    color: ${colourScheme.fullWhite};
    position: relative;
`;

export const DropdownContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
`;
